import type {PreOrderRetrieveResponse} from '@yandex-delivery/api/repo/dcaa'
import {isNotUndefined} from '@yandex-delivery/utils'

import type {SelectedRequirementsMap} from 'src/shared/types'

export const toSelectedRequirementsMap = (preOrderRetrieve: PreOrderRetrieveResponse): SelectedRequirementsMap => {
  const requirements: SelectedRequirementsMap = {
    insurance: true,
  }

  const offerRequirements = preOrderRetrieve.claim.offer_requirements

  if (offerRequirements?.cargo_type) {
    requirements.cargo_type = offerRequirements.cargo_type
  }

  if (isNotUndefined(offerRequirements?.cargo_loaders)) {
    requirements.cargo_loaders = offerRequirements.cargo_loaders
  }

  if (isNotUndefined(offerRequirements?.skip_door_to_door)) {
    requirements.door_to_door = !Boolean(preOrderRetrieve.claim.offer_requirements?.skip_door_to_door)
  }

  return requirements
}
